const DEFAULT_ROOT_ELEMENT_ID = "ql-data-points";

/**
 * Returns the shared channel-validation options for episode audio uploaders.
 *
 * @param rootElement - The page root that stores uploader config.
 * @returns Shared stereo preprocessor options for the current episode page.
 */
export function getEpisodeAudioChannelValidationOptions(
  rootElement = document.getElementById(DEFAULT_ROOT_ELEMENT_ID)
) {
  return {
    skipChannelValidation: rootElement?.dataset.skipChannelValidation === "true",
  };
}
